import axiosInstance from "axios";
import { getAuthToken } from "../utils/auth";

const BASE_URL = process.env.REACT_APP_SERVER_API_URL;
const BASE_URL_V1 = process.env.REACT_APP_SERVER_API_URL_V1;

export const getRoom = async (opts?: { token?: string }): Promise<any> => {
  try {
    const token = opts?.token ?? getAuthToken();
    if (!token)
      throw new Error(
        "Missing auth token. Provide ?jwt=... or set session storage."
      );
    const url = `${BASE_URL}/game-ticket/get-room`;
    const res = await axiosInstance.get(url, {
      headers: { authorization: "Bearer " + token },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

export const getTicketByBill = async ({
  billId,
  token,
}: {
  billId: string;
  token?: string;
}): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/get-by-bill/${billId}`;
    const res = await axiosInstance.get(url, {
      headers: { authorization: "Bearer " + t },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

type BuyTicketPayload = {
  selectTicketNumbers: number[];
  roomId: string;
  token?: string;
};

export const buyTicket = async ({
  selectTicketNumbers,
  roomId,
  token,
}: BuyTicketPayload): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/buy`;
    const res = await axiosInstance.post(
      url,
      {
        selectTicketNumbers,
        roomId,
      },
      {
        headers: { authorization: "Bearer " + t },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};
export const buyPromotionTicket = async ({
  selectTicketNumbers,
  roomId,
  token,
}: BuyTicketPayload): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/promotion/buy`;
    const res = await axiosInstance.post(
      url,
      {
        selectTicketNumbers,
        roomId,
      },
      {
        headers: { authorization: "Bearer " + t },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

export const callUseTicket = async ({
  ticketId,
  token,
}: {
  ticketId: string;
  token?: string;
}): Promise<any> => {
  try {
    console.log("call use ticket...");
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/use/${ticketId}`;
    const res = await axiosInstance.post(url, null, {
      headers: { authorization: "Bearer " + t },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

/**
 * Get ticket detail by ticket id
 * Falls back to `getAuthToken()` if no `token` is provided
 */
export const getTicketDetailById = async ({
  ticketId,
  token,
}: {
  ticketId: string;
  token?: string;
}): Promise<any> => {
  try {
    console.log("first 123");
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/get-one/${ticketId}`;
    const res = await axiosInstance.get(url, {
      headers: { authorization: "Bearer " + t },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

/**
 * Get bills with pagination
 * Falls back to `getAuthToken()` if no `token` is provided
 */
export const getBills = async ({
  limit = 10,
  skip = 0,
  token,
}: {
  limit?: number;
  skip?: number;
  token?: string;
}): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/get-bills?limit=${limit}&skip=${skip}`;
    const res = await axiosInstance.get(url, {
      headers: { authorization: "Bearer " + t },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

export const getRewards = async ({
  limit = 10,
  skip = 0,
  token,
}: {
  limit?: number;
  skip?: number;
  token?: string;
}): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/get-rewards?limit=${limit}&skip=${skip}`;
    const res = await axiosInstance.get(url, {
      headers: { authorization: "Bearer " + t },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

export const checkUnusedTicket = async ({
  token,
}: {
  token?: string;
}): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/check-unused-tickets`;
    const res = await axiosInstance.get(url, {
      headers: { authorization: "Bearer " + t },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};
export const checkUnusedTicketCount = async ({
  token,
}: {
  token?: string;
}): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/check-unused-tickets/count`;
    const res = await axiosInstance.get(url, {
      headers: { authorization: "Bearer " + t },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

export const checkPromotionUnused = async ({
  token,
}: {
  token?: string;
}): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL}/game-ticket/check-promotion-unused`;
    const res = await axiosInstance.get(url, {
      headers: { authorization: "Bearer " + t },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

export const tokenGetMe = async ({
  token,
}: {
  token?: string;
}): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    if (!t) throw new Error("Missing auth token.");
    const url = `${BASE_URL_V1}/token/get-me`;
    const res = await axiosInstance.get(url, {
      headers: {
        ...axiosInstance.defaults.headers.common,
        authorization: "Bearer " + t,
      },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};

export const coinGetMe = async ({
  token,
}: {
  token?: string;
}): Promise<any> => {
  try {
    const t = token ?? getAuthToken();
    const url = `${BASE_URL_V1}/coin/get-me`;
    const res = await axiosInstance.get(url, {
      headers: {
        ...axiosInstance.defaults.headers.common,
        authorization: "Bearer " + t,
      },
    });
    return res.data;
  } catch (error: any) {
    console.error("error", error);
    throw error;
  }
};
